import React from 'react';
import './Footer.css';
import CircularText from '../animation/CircularText';
import DecryptedText from '../animation/DecryptedText';

const Footer = ({ isDetailView, onScrollToNext }) => {
  return (
    <footer className="footer">
      <div className="footer-left">
        © 2025 Jackie S · Built with love & caffeine ☕
        <span className="inspired-by">
          &nbsp;•&nbsp;Inspired by{' '}
          <a
            href="https://www.awwwards.com/sites/federico-pian-portfolio-2024"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link-underline"
          >
            <DecryptedText text="Federico Pian" speed={40} maxIterations={20} />
          </a>

        </span>
      </div>

      {!isDetailView && (
        <div className="footer-right" onClick={onScrollToNext}>
          <CircularText
            text="SCROLL TO EXPLORE • "
            onHover="speedUp"
            spinDuration={8}
            className="circular-scroll"
          />
        </div>
      )}
    </footer>
  );
};

export default Footer;
